import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "appFont" }
const _hoisted_4 = {
  key: 1,
  class: "text-center"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "appFont" }
const _hoisted_7 = {
  key: 2,
  class: "text-center"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "appFont" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PremiumBuy = _resolveComponent("PremiumBuy")!
  const _component_Post = _resolveComponent("Post")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_HappySmile = _resolveComponent("HappySmile")!
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wrapper my-4 pt-16 pb-24 md:pb-5", {'pt-5':_ctx.singleQuestion}]),
    style: _normalizeStyle(_ctx.styles)
  }, [
    (!_ctx.user().is_premium)
      ? (_openBlock(), _createBlock(_component_PremiumBuy, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("main", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts, (post) => {
        return (_openBlock(), _createBlock(_component_Post, {
          key: post.id,
          post: post,
          "check-button": true
        }, null, 8, ["post"]))
      }), 128)),
      (_ctx.loadingMore || _ctx.posts.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_Spinner, { class: "fa-2x" }),
            _hoisted_2,
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('Just a moment')) + " ;)", 1)
          ]))
        : (_ctx.allLoaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_HappySmile, { class: "fa-2x" }),
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('Take a break, that\'s all for now')) + " :D", 1)
            ]))
          : _createCommentVNode("", true),
      (_ctx.failedMore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_Error, { class: "fa-2x" }),
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('Failed to load more')) + " :(", 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 6))
}